<template>
  <div>
    <section class="section-b-space light-layout">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="success-text">
              <h2>{{ message }}</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { baseMixin } from '@/libs/app-mixin'
import { confirmUser } from '@/api/user'

export default {
  name: 'Confirm',
  mixins: [baseMixin],
  data () {
    return {
      message: ''
    }
  },
  methods: {
    confirmUser () {
      confirmUser({
        email: this.$route.params.email
      }).then(res => {
        if (res.code !== 200) {
          this.$message.info(res.msg)
          this.message = res.msg
          return false
        }
        this.$message.success('账号激活成功')
        this.message = '账号激活成功'
        setTimeout(() => {
          location.href = '/#/'
        }, 3000)
      })
    }
  },
  mounted () {
    if (typeof this.$route.params.email !== 'undefined') {
      this.confirmUser()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/My/Confirm.vue